import { Tenant, TENANT_NAME } from '../tenants';

export const useIsTenant = (tenant: Tenant): boolean => TENANT_NAME === tenant;
